var _mask, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_563_5565",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22V26C19.732 26 26 19.732 26 12H22ZM12 22C6.47715 22 2 17.5228 2 12H-2C-2 19.732 4.26801 26 12 26V22ZM2 12C2 6.47715 6.47715 2 12 2V-2C4.26801 -2 -2 4.26801 -2 12H2ZM12 2C17.5228 2 22 6.47715 22 12H26C26 4.26801 19.732 -2 12 -2V2Z",
    fill: "#00C68E",
    mask: "url(#path-1-inside-1_563_5565)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEmpty);
export default __webpack_public_path__ + "static/media/circle-empty.9cf5c33357989412ed2270287f7e4161.svg";
export { ForwardRef as ReactComponent };